import { useState } from 'react';
import { Filters, TFilterForm } from './filters';
import { useApiHelper } from './helpers/apiHelper';
import { SearchBox } from '../../../components';
import './index.scss';
import dayjs from 'dayjs';
import { MatrixCards } from '../common/matrixCards';
import { TransactionReport } from './report';
import { Table } from './table';

const currDate = new Date();
export const Transactions: React.FC<{
  enterpriseId: number | undefined;
}> = ({ enterpriseId }) => {
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState<TFilterForm>({
    status: '',
    startDate: dayjs(currDate).subtract(7, 'days').toDate(),
    endDate: dayjs(currDate).toDate(),
  });
  const [searchString, setSearchString] = useState('');

  const { transactionsData, formattedMatrixData } =
    useApiHelper(
      pageNo,
      pageSize,
      filters,
      searchString,
      enterpriseId
    );

  return (
    <div>
      <div className="top-header mt-2">
        <div className="contents justify-between">
          <span className="disclaimer-text">
            {`Note: Data is correctly reflected from 21st
            Nov'22 onwards. Transactions made before this
            may have incomplete data in few instances.`}
          </span>
          {enterpriseId && (
            <TransactionReport
              enterpriseId={enterpriseId}
            />
          )}
        </div>
      </div>
      <div className="flex justify-between my-7">
        <div className="flex">
          <SearchBox
            className="mr-3"
            placeholder="Search by Invoice No, Order No, UTR No."
            searchValue={searchString}
            setSearchString={setSearchString}
          />
          <Filters
            filters={filters}
            setFilters={setFilters}
          />
        </div>
      </div>
      <MatrixCards matrixData={formattedMatrixData} />
      <Table
        enterpriseId={enterpriseId}
        transactions={transactionsData}
        setPage={setPageNo}
        page={pageNo}
        rowsPerPage={pageSize}
        setRowsPerPage={setPageSize}
      />
    </div>
  );
};
